<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>Field Configuration</h3>
      <p>{{ register?.name }}</p>
    </header>

    <form [formGroup]="fieldForm" (ngSubmit)="submit()">
      <div class="form-row">
        <div class="form-item">
          <label>Field Name <small>*</small></label>
          <input type="text" formControlName="name" />
          <div class="error" *ngIf="fieldForm.get('name')?.invalid && fieldForm.get('name')?.touched">
            <small>Field name is required</small>
          </div>
        </div>
        <div class="form-item">
          <label>Type <small>*</small></label>
          <select formControlName="data_type">
            <option *ngFor="let type of fieldTypes" [value]="type.value">{{ type.label }}</option>
          </select>
        </div>
        <div class="form-item">
          <label>Step</label>
          <select formControlName="step_number">
            <option *ngFor="let step of steps" [value]="step.step">{{ step.label }}</option>
          </select>
        </div>
        <div class="form-item">
          <label>Sequence</label>
          <input type="number" formControlName="sequence" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-item">
          <label><input type="checkbox" formControlName="is_mandatory" /> Mandatory</label>
        </div>
        <div class="form-item">
          <label><input type="checkbox" formControlName="is_unique" /> Unique</label>
        </div>
        <div class="form-item">
          <label><input type="checkbox" formControlName="is_searchable" /> Searchable</label>
        </div>
        <div class="form-item">
          <label><input type="checkbox" formControlName="is_filterable" /> Filterable</label>
        </div>
      </div>

      <div class="form-row">
        <div class="form-item">
          <label>Min Length</label>
          <input type="number" formControlName="min_length" />
        </div>
        <div class="form-item">
          <label>Max Length</label>
          <input type="number" formControlName="max_length" />
        </div>
        <div class="form-item">
          <label><input type="checkbox" formControlName="is_numeric" /> Numeric</label>
        </div>
        <div class="form-item">
          <label><input type="checkbox" formControlName="is_decimal" /> Decimal</label>
        </div>
      </div>

      <div class="form-row" *ngIf="shouldShowCluster()">
        <div class="form-item">
          <label>Cluster</label>
          <select formControlName="cluster">
            <option [ngValue]="null">Select</option>
            <option *ngFor="let cluster of clusters" [ngValue]="cluster.id">{{ cluster.name }}</option>
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-item">
          <label>Help Text</label>
          <textarea rows="2" formControlName="help_text"></textarea>
        </div>
        <div class="form-item">
          <label>Status</label>
          <select formControlName="is_active">
            <option [ngValue]="true">Active</option>
            <option [ngValue]="false">Inactive</option>
          </select>
        </div>
      </div>

      <div class="button-row">
        <button type="submit" class="btn-save">
          {{ isEditMode ? 'Update Field' : 'Add Field' }}
        </button>
        <button type="button" class="btn-cancel" (click)="resetForm()">Clear</button>
        <button type="button" class="btn-cancel" (click)="goBack()">Back</button>
      </div>
    </form>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Field Name</th>
            <th>Type</th>
            <th>Step</th>
            <th>Mandatory</th>
            <th>Sequence</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let field of fields">
            <td>{{ field.name }}</td>
            <td>{{ field.data_type }}</td>
            <td>{{ field.step_number }}</td>
            <td>{{ field.is_mandatory ? 'Yes' : 'No' }}</td>
            <td>{{ field.sequence }}</td>
            <td>
              <span [ngClass]="field.is_active ? 'green-circle' : 'red-circle'"></span>
            </td>
            <td>
              <button class="action-button bt-edit" (click)="editField(field)" title="Edit">
                <fa-icon [icon]="['fas', 'pen']"></fa-icon>
              </button>
              <button class="action-button bt-delete" (click)="deleteField(field.id)" title="Delete">
                <fa-icon [icon]="['fas', 'trash']"></fa-icon>
              </button>
            </td>
          </tr>
          <tr *ngIf="fields.length === 0">
            <td colspan="7">No fields configured.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
